export enum CustomPageLayout {
    STANDARD = 0,
    EXTENSIBLE = 1,
}

export enum NodeMenuType {
    none = 'none',
    add = 'add',
    remove = 'remove',
    addMenu = 'addMenu',
}

export interface CpRootNode {
    id: string;
    name: string;
    idAddMenuDataSource?: string;
    autoNormalValues: boolean;
    description: string;
}
